import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@4.2.1_@libsql+client@0.15.15_@parcel+watcher@2.5.1_@types+node@24.10.0_@vercel+blo_d6f82ecef7735b0ae36305d0e860f4a4/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}